<form [formGroup]="form" (submit)="duplicarChecklistHandler()">
    <div class="modal-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 form-group">
                    <label for="nombreCheckListDuplicado">Nombre:</label>
                    <input
                        type="text"
                        id="nombreCheckListDuplicado"
                        name="nombreCheckListDuplicado"
                        formControlName="nombreCheckListDuplicado"
                        class="form-control"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button [disabled]="form.invalid" type="submit" class="btn btn-primary primary">
            agregar revisión
        </button>
    </div>
</form>